import React, { useEffect, useState } from 'react';
import axios from 'axios';
import logo_icon_28 from '../assets/images/logo-icon-28.png';
import logo_dark from '../assets/images/logo-dark.svg';
import logo_white from '../assets/images/logo-white.png';
import image from '../assets/images/avatar/1.jpg';
import { Link } from "react-router-dom";
import { LuSearch, LuSettings } from 'react-icons/lu';
import { AiOutlineCopy, AiOutlineUser } from 'react-icons/ai';
import { LiaSignOutAltSolid } from 'react-icons/lia';
import { PiWalletBold } from 'react-icons/pi';

export default function Navbar() {
    const [isDropdown, openDropdown] = useState(true);
    const [isOpen, setMenu] = useState(true);
    const [user, setUser] = useState(null); // Store user information
    const [copied, setCopied] = useState(false);
    useEffect(() => {
        activateMenu();
        checkUserAuth();
    });
    const handleLogout = () => {
        // Удаляем токен из localStorage или sessionStorage
        localStorage.removeItem('token'); // Если вы используете sessionStorage, замените это на sessionStorage.removeItem('token')
    
        // Сброс состояния пользователя
        setUser(null);
    
        // Перенаправляем на страницу входа (если используется React Router)
        window.location.href = '/login'; // Или используйте `useNavigate` из `react-router-dom`
    };
    
    const checkUserAuth = async () => {
        try {
            const response = await axios.get('https://nifty-art.com/api/auth/user', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}` // Используйте токен из хранилища
                }
            });
            setUser(response.data.user); // Устанавливаем данные пользователя
            
        } catch (error) {
            setUser(null); // Сбросить user на null, если не аутентифицирован
        }
    };
    
    window.addEventListener("scroll", windowScroll);
    function windowScroll() {
        const navbar = document.getElementById("topnav");
        if (
            document.body.scrollTop >= 50 ||
            document.documentElement.scrollTop >= 50
        ) {
            if (navbar !== null) {
                navbar?.classList.add("nav-sticky");
            }
        } else {
            if (navbar !== null) {
                navbar?.classList.remove("nav-sticky");
            }
        }

        const mybutton = document.getElementById("back-to-top");
        if (mybutton != null) {
            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                mybutton.classList.add("flex");
                mybutton.classList.remove("hidden");
            } else {
                mybutton.classList.add("hidden");
                mybutton.classList.remove("flex");
            }
        }
    }

    const toggleMenu = () => {
        setMenu(!isOpen)
        if (document.getElementById("navigation")) {
            const anchorArray = Array.from(document.getElementById("navigation").getElementsByTagName("a"));
            anchorArray.forEach(element => {
                element.addEventListener('click', (elem) => {
                    const target = elem.target.getAttribute("href")
                    if (target !== "") {
                        if (elem.target.nextElementSibling) {
                            var submenu = elem.target.nextElementSibling.nextElementSibling;
                            submenu.classList.toggle('open');
                        }
                    }
                })
            });
        }
    }

    const getClosest = (elem, selector) => {

        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) { }
                    return i > -1;
                };
        }

        // Get the closest matching element
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) return elem;
        }
        return null;

    };
    const handleCopy = () => {
        if (user.metamaskAddress) {
            navigator.clipboard.writeText(user.metamaskAddress) // Копируем адрес в буфер обмена
                .then(() => {
                    setCopied(true); // Устанавливаем "Copied!" состояние
                    setTimeout(() => setCopied(false), 4000); // Убираем текст через 2 секунды
                })
                .catch(err => console.error('Failed to copy:', err));
        }
    };
    const activateMenu = () => {
        var menuItems = document.getElementsByClassName("sub-menu-item");
        if (menuItems) {

            var matchingMenuItem = null;
            for (var idx = 0; idx < menuItems.length; idx++) {
                if (menuItems[idx].href === window.location.href) {
                    matchingMenuItem = menuItems[idx];
                }
            }

            if (matchingMenuItem) {
                matchingMenuItem.classList.add('active');


                var immediateParent = getClosest(matchingMenuItem, 'li');

                if (immediateParent) {
                    immediateParent.classList.add('active');
                }

                var parent = getClosest(immediateParent, '.child-menu-item');
                if (parent) {
                    parent.classList.add('active');
                }

                var parent = getClosest(parent || immediateParent, '.parent-menu-item');

                if (parent) {
                    parent.classList.add('active');

                    var parentMenuitem = parent.querySelector('.menu-item');
                    if (parentMenuitem) {
                        parentMenuitem.classList.add('active');
                    }

                    var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                } else {
                    var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                }
            }
        }
    }

    const metamask = async () => {
        try {
            //Basic Actions Section
            const onboardButton = document.getElementById('connectWallet')

            //   metamask modal
            const modal = document.getElementById('modal-metamask')
            const closeModalBtn = document.getElementById('close-modal')

            //   wallet address
            const myPublicAddress = document.getElementById('myPublicAddress')

            //Created check function to see if the MetaMask extension is installed
            const isMetaMaskInstalled = () => {
                //Have to check the ethereum binding on the window object to see if it's installed
                const { ethereum } = window
                return Boolean(ethereum && ethereum.isMetaMask)
            }

            const onClickConnect = async () => {
                if (!isMetaMaskInstalled()) {
                    //meta mask not installed
                    modal.classList.add('show')
                    modal.style.display = 'block'
                    return
                }
                try {
                    // eslint-disable-next-line no-undef
                    await ethereum.request({ method: 'eth_requestAccounts' })
                    // eslint-disable-next-line no-undef
                    const accounts = await ethereum.request({ method: 'eth_accounts' })
                    myPublicAddress.innerHTML =
                        accounts[0].split('').slice(0, 6).join('') +
                        '...' +
                        accounts[0]
                            .split('')
                            .slice(accounts[0].length - 7, accounts[0].length)
                            .join('')
                } catch (error) {
                }
            }

            const closeModal = () => {
                modal.classList.remove('show')
                modal.style.display = 'none'
            }

            if (isMetaMaskInstalled()) {
                // eslint-disable-next-line no-undef
                const accounts = await ethereum.request({ method: 'eth_accounts' })
                if (!!accounts[0]) {
                    myPublicAddress.innerHTML =
                        accounts[0].split('').slice(0, 6).join('') +
                        '...' +
                        accounts[0]
                            .split('')
                            .slice(accounts[0].length - 7, accounts[0].length)
                            .join('')
                }
            }

            onboardButton.addEventListener('click', onClickConnect)
            closeModalBtn.addEventListener('click', closeModal)
        } catch (error) { }
    }

    return (
        <>
            <nav id="topnav" className="defaultscroll is-sticky">
                <div className="container">
                    {/* <!-- Logo container--> */}
                    <Link className="logo ps-0" to="/">
                        <img src={logo_icon_28} className="inline-block sm:hidden" alt="" />
                        <div className="sm:block hidden">
                            <img src={logo_dark} className="inline-block dark:hidden h-7" alt="" />
                            <img src={logo_white} className="hidden dark:inline-block h-7" alt="" />
                        </div>
                    </Link>

                    <div className="menu-extras">
                        <div className="menu-item">
                            {/* <!-- Mobile menu toggle--> */}
                            <Link to="#" className="navbar-toggle" id="isToggle" onClick={toggleMenu}>
                                <div className="lines">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </Link>
                        </div>
                    </div>

                    {/* <!--Login button Start--> */}
                    <ul className="buy-button list-none mb-0">
                        
                        <li className="dropdown inline-block relative ps-1">
                            {user ? (
                                <>
                                    <button onClick={() => openDropdown(!isDropdown)} className="dropdown-toggle btn btn-icon rounded-full bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white inline-flex" type="button">
                                        <img src={user.avatar || image} className="rounded-full w-10 h-10" alt="User Avatar" />
                                    </button>
                                    
                                    <div className={`dropdown-menu absolute end-0 m-0 mt-4 z-10 w-48 rounded-md overflow-hidden bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 ${isDropdown ? 'hidden' : 'block'}`} >
                                        <div className="relative">
                                            <div className="py-8 bg-gradient-to-tr from-violet-600 to-red-600"></div>
                                            <div className="absolute px-4 -bottom-7 start-0">
                                                <div className="flex items-end">
                                                    <img src={user.avatar || image} className="rounded-full w-10 h-10" alt="User Avatar" />
                                                    <span className="font-semibold text-[15px] ms-1">{user.firstName} {user.lastName}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-10 px-4">
                                            <h5 className="font-semibold text-[15px]">Wallet:</h5>
                                            <div className="flex items-center justify-between">
                                                <span className="text-[13px] text-slate-400">
                                                    {user.metamaskAddress
                                                        ? `${user.metamaskAddress.slice(0, 6)}...${user.metamaskAddress.slice(-6)}`
                                                        : 'No address available'}
                                                </span>
                                                <button
                                                    onClick={handleCopy}
                                                    className="text-violet-600 flex items-center focus:outline-none"
                                                >
                                                    {!copied ? (
                                                        <AiOutlineCopy />
                                                    ) : (
                                                        <span className="text-green-500 text-[12px]">Copied!</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        <ul className="py-2 text-start">
                                            <li>
                                                <Link to={`/creator-profile/${user.username}`} className="inline-flex items-center text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><AiOutlineUser className="text-[16px] align-middle me-1"/> Profile</Link>
                                            </li>
                                            <li>
                                                <Link to={`/creator-profile-edit/${user._id}`} className="inline-flex items-center text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><LuSettings className="text-[16px] align-middle me-1"/> Settings</Link>
                                            </li>
                                            <li className="border-t border-gray-100 dark:border-gray-800 my-2"></li>
                                            <li>
                                                <button onClick={handleLogout} className="inline-flex items-center text-[14px] font-semibold py-1.5 px-4 hover:text-violet-600"><LiaSignOutAltSolid className="text-[16px] align-middle me-1"/> Logout</button>
                                            </li>
                                        </ul>
                                    </div>
                                </>
                            ) : (
                                <Link to="/login" className="btn btn-icon rounded-full bg-violet-600 hover:bg-violet-700 border-violet-600 hover:border-violet-700 text-white">
                                    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.00098 11.999L16.001 11.999M16.001 11.999L12.501 8.99902M16.001 11.999L12.501 14.999" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"></path>
                                    </svg>
                                </Link>
                            )}
                        </li>
                    </ul>

                    <div id="navigation" className={`${isOpen === true ? 'hidden' : 'block'}`}>
                        <ul className="navigation-menu justify-end">
                            <li className="has-submenu parent-menu-item">
                                <Link to="/">Home</Link>
                            </li>

                            <li className="has-submenu parent-parent-menu-item">
                                <Link to="/explore-one">Explore</Link>
                            </li>

                            <li><Link to="/wallet" className="sub-menu-item">Wallet</Link></li>

                            
                            <li><Link to="/creators" className="sub-menu-item"> Creators</Link></li>
                

                            <li><Link to="/contact" className="sub-menu-item">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>

        </>
    )
}
